import { css } from 'emotion';

export const quoteMedia = css(`
	text-align: center;
`);
